(function () {
  function initIngredientsList(section) {
    var glossary = section.querySelector('[data-ingredients-glossary]');
    var showBtn = section.querySelector('[data-ingredients-show]');
    var hideBtn = section.querySelector('[data-ingredients-hide]');
    var legendBtns = section.querySelectorAll('.ingredients-legend__btn');
    var panels = section.querySelectorAll('.ingredients-panel');

    if (showBtn && hideBtn && glossary) {
      showBtn.addEventListener('click', function () {
        glossary.classList.add('active');
        showBtn.classList.add('active');
        hideBtn.classList.remove('active');
      });

      hideBtn.addEventListener('click', function () {
        glossary.classList.remove('active');
        showBtn.classList.remove('active');
        hideBtn.classList.add('active');
      });
    }

    legendBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var letter = btn.getAttribute('data-letter');

        legendBtns.forEach(function (legendBtn) {
          var isActive = legendBtn === btn;
          legendBtn.classList.toggle('active', isActive);
          legendBtn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.id === 'ingredients-panel-' + letter;
          panel.classList.toggle('active', isActive);
          panel.hidden = !isActive;
        });
      });
    });
  }

  document.querySelectorAll('[data-ingredients-list]').forEach(initIngredientsList);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-ingredients-list]');
    if (section) initIngredientsList(section);
  });
})();
